import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  Spin,
  Space,
  DatePicker,
  Checkbox,
  AutoComplete,
} from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import config from "../../config";
import authHeader from "../Authentication/authHeader";
import "./Inventory.css";
import InvoiceModal from "./InvoiceModal";
import CustomerModal from "./CustomerModal";

export default function GUISales() {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [orderType, setOrderType] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [filteredProductsList, setFilteredProductsList] = useState([]);
  const [viewModal, setViewModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [invoiceResponseData, setInvoiceResponse] = useState(null);

  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [customerModalVisibility, setCustomerModalVisibility] = useState(false);
  const [isBackLog, setIsBackLog] = useState(false);

  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile"))
  );

  const [options, setOptions] = useState([]);
  const [phone, setPhone] = useState("");

  const fetchGuiProductList = () => {
    axios
      .get(
        `${config.baseUrl}/inventory/gui_stock_list/${userProfile?.employee_id}/`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        setProductList(response?.data || []);
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/contractFarming/projects/`, {
        headers: authHeader(),
      })
      .then((response) => setProjects(response?.data))
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    fetchGuiProductList();
  }, [userProfile?.employee_id]);

  const distinct_product_name = [
    ...new Set(productList?.map((item) => item?.product?.product_name)),
  ];

  const filterProductList = (value, index) => {
    const filteredProducts = productList.filter(
      (product) =>
        product.product.product_name.toLowerCase() === value.toLowerCase()
    );
    setFilteredProductsList(filteredProducts);
    const newValues = form.getFieldsValue();
    newValues.products[index] = {
      ...newValues.products[index],
      batch_id: undefined,
      quantity: undefined,
      discount: undefined,
      product_total_price: undefined,
      remaining_stock: undefined,
      selling_price: undefined,
    };

    form.setFieldsValue({ products: [...newValues.products] });
  };

  const handleBackLogData = (e) => {
    setIsBackLog(e.target.checked);
  };

  const openCustomerModal = () => {
    setCustomerModalVisibility(true);
  };
  const handleModalClose = () => {
    setCustomerModalVisibility(false);
  };

  const handleOrderType = (value) => {
    setOrderType(value);
    setPhone(null);
    setOptions([]);
    form.setFieldsValue({
      products: [],
      total_paid: null,
      due: null,
      farmer_name: null,
      farmer_id: null,
      phoneNumber: null,
      retailer_name: null,
      retailer_id: null,
      phone_number: null,
      contractPhoneNumber: null,
      contract_farmer_name: null,
      contract_farmer_id: null,
      group_name: null,
      project_id: null,
      institutional_buyer_name: null,
    });
  };
  const handlePhoneSearch = (value) => {
    setPhone(value);
    if (value.length >= 3) {
      axios
        .get(`${config.baseUrl}/inventory/pos_search_phone_numbers?`, {
          params: { prefix: value, customer_type: orderType },
          headers: authHeader(),
        })
        .then((data) => {
          const phoneNumbers = data?.data?.matchingPhoneNumbers || [];
          setOptions(
            phoneNumbers.map((num) => ({
              value: 0 + num,
            }))
          );
        })
        .catch((error) => {
          console.error("Error fetching phone numbers:", error);
          setOptions([]);
        });
    } else {
      setOptions([]);
    }
  };

  const handlePhoneSelect = (selectedPhone) => {
    const customerType = form.getFieldValue("customer_type");
    form.setFieldsValue({
      phoneNumber: selectedPhone,
    });

    const phoneChangeEvent = { target: { value: selectedPhone } };

    if (customerType === "Farmer" || customerType === "Contract") {
      handleFarmerInfo(phoneChangeEvent);
    } else if (customerType === "Retailer") {
      handleRetailerInfo(phoneChangeEvent);
    } else if (customerType === "Institutional") {
      handleInstitutionalInfo(phoneChangeEvent);
    } else if (customerType === "Regular") {
      handleRegularCustomerInfo(phoneChangeEvent);
    } else if (customerType === "Contract") {
      handleContractFarmerInfo(phoneChangeEvent);
    } else {
      console.error("Invalid customer type");
    }
  };
  const handlePhoneChange = (e, customerType) => {
    setPhone(e.target.value);
    if (customerType === "Farmer") {
      handleFarmerInfo(e);
    } else if (customerType === "Retailer") {
      handleRetailerInfo(e);
    } else if (customerType === "Regular") {
      handleRegularCustomerInfo(e);
    } else if (customerType === "Institutional") {
      handleInstitutionalInfo(e);
    } else if (customerType === "Contract") {
      handleContractFarmerInfo(e);
    } else {
      console.error("Invalid customer type");
    }
  };

  const renderPhoneField = (customerType) => (
    <Col style={{ width: "400px" }}>
      <Form.Item
        hasFeedback
        label="Customer Number"
        name="phoneNumber"
        onChange={(e) => handlePhoneChange(e, customerType)}
        rules={[
          {
            required: true,
            message: "Please enter customer's phone number",
          },
          {
            pattern: /^(?:\+?88)?01[3-9]\d{8}$/,
            message: "Please enter a valid phone number",
          },
        ]}
      >
        <AutoComplete
          options={options}
          onSearch={handlePhoneSearch}
          onSelect={handlePhoneSelect}
          placeholder="Phone Number"
          value={phone}
        >
          <Input type="tel" />
        </AutoComplete>
      </Form.Item>
    </Col>
  );

  const handleProductSelect = (value, index) => {
    const newValues = { ...form.getFieldsValue() };
    // const rateKey =
    //   orderType.toLowerCase() === "retailer"
    //     ? "selling_rate_retailer"
    //     : orderType.toLowerCase() === "farmer"
    //     ? "selling_rate_farmer"
    //     : orderType.toLowerCase() === "institutional"
    //     ? "selling_rate_institutional_buyer"
    //     : orderType.toLowerCase() === "regular"
    //     ? "selling_rate_regular"
    //     : "selling_rate_contract_farmer";
    const selectedProduct = filteredProductsList.find(
      (product) => product.batch_id === value
    );

    newValues.products[index].purchase_price = selectedProduct?.purchase_price;
    newValues.products[index].remaining_stock = selectedProduct?.stock;
    // newValues.products[index].selling_price = selectedProduct[rateKey];
    newValues.products[index]["product_id"] =
      selectedProduct.product.product_id;
    form.setFieldsValue({ ...newValues });
  };
  const handleProjectInfo = (value) => {
    const selectedProjectDetails = projects?.find(
      (project) => project.project_id === value
    );
    setSelectedProject(selectedProjectDetails);
  };
  const handleContractFarmerGroup = (value) => {
    setSelectedGroup(value);
  };

  const handleFarmerInfo = (e) => {
    const phone = e.target.value;
    if (phone.length === 11) {
      axios
        .get(`${config.baseUrl}/api/farmer_info/${phone}/`, {
          headers: authHeader(),
        })
        .then((data) => {
          form.setFieldsValue({
            farmer_name: data?.data?.name,
            farmer_id: data?.data?.farmer_id,
          });
        })
        .catch((error) => {
          form.setFieldsValue({
            farmer_name: undefined,
            farmer_id: undefined,
          });
          Swal.fire({
            title: "Error",
            text: "Farmer Not Found",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleRetailerInfo = (e) => {
    const phone = e.target.value;
    if (phone.length === 11) {
      axios
        .get(`${config.baseUrl}/retailer/retailer_info/${phone}/`, {
          headers: authHeader(),
        })
        .then((data) => {
          form.setFieldsValue({
            retailer_name: data?.data?.name,
            retailer_id: data?.data?.retailer_id,
          });
        })
        .catch((error) => {
          form.setFieldsValue({
            retailer_name: undefined,
            retailer_id: undefined,
          });
          Swal.fire({
            title: "Error",
            text: "Retailer Not Found",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleRegularCustomerInfo = (e) => {
    const phone = e.target.value;
    if (phone.length === 11) {
      axios
        .get(`${config.baseUrl}/inventory/regular_customer_info/${phone}/`, {
          headers: authHeader(),
        })
        .then((data) => {
          form.setFieldsValue({
            regular_customer_name: data?.data?.name,
            regular_customer_id: data?.data?.customer_id,
          });
        })
        .catch((error) => {
          form.setFieldsValue({
            regular_customer_name: undefined,
            regular_customer_id: undefined,
          });
          Swal.fire({
            title: "Error",
            text: "Regular Customer Not Found",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleContractFarmerInfo = (e) => {
    const phone = e.target.value;
    if (phone.length === 11) {
      axios
        .get(`${config.baseUrl}/api/contract_farmer_info_ops/`, {
          headers: authHeader(),
          params: {
            project: selectedProject?.project_id,
            group_name: selectedGroup,
            phone: phone,
          },
        })
        .then((data) => {
          console.log(data);
          form.setFieldsValue({
            contract_farmer_name: data?.data?.farmer?.name,
            contract_farmer_id: data?.data?.farmer?.farmer_id,
          });
        })
        .catch((error) => {
          form.setFieldsValue({
            contract_farmer_name: undefined,
            contract_farmer_id: undefined,
          });
          Swal.fire({
            title: "Error",
            text: "Farmer Not Found",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const handleInstitutionalInfo = (e) => {
    const phone = e.target.value;
    if (phone.length === 11) {
      axios
        .get(`${config.baseUrl}/trader/ibInfo/${phone}/`, {
          headers: authHeader(),
        })
        .then((data) => {
          form.setFieldsValue({
            institutional_buyer_name: data?.data?.institutional_buyer_name,
          });
        })
        .catch((error) => {
          form.setFieldsValue({
            institutional_buyer_name: undefined,
          });
          Swal.fire({
            title: "Error",
            text: "Farmer Not Found",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };

  const calculateTotalPrice = () => {
    const formValues = form.getFieldsValue();
    const products = formValues.products || [];

    const newTotalPriceSum = products.reduce((sum, product) => {
      return sum + (parseFloat(product.product_total_price) || 0);
    }, 0);

    form.setFieldsValue({ total_price: Math.trunc(newTotalPriceSum) });
    handleTotalPaidChange();
  };

  const handleSaleRateChange = (value, index) => {
    const newValues = { ...form.getFieldsValue() };

    if (!newValues.products || !newValues.products[index]) {
      return;
    }

    const product = newValues.products[index];
    const rate = value ? parseInt(value, 10) : 0;
    const quantity = parseFloat(product.quantity) || 0;
    const discount = parseFloat(product.discount) || 0;

    const calculatedTotalPrice = Math.max(rate * quantity - discount, 0);

    newValues.products[index].product_total_price =
      calculatedTotalPrice.toFixed(2);

    form.setFieldsValue(newValues);
    calculateTotalPrice();
  };

  const handleQuantityChange = (value, index) => {
    const newValues = { ...form.getFieldsValue() };

    if (!newValues.products || !newValues.products[index]) {
      return;
    }

    const product = newValues.products[index];
    const rate = parseFloat(product.selling_price) || 0;
    const discount = parseFloat(product.discount) || 0;
    const quantity = value ? parseInt(value, 10) : 0;

    const calculatedTotalPrice = Math.max(rate * quantity - discount, 0);

    newValues.products[index].product_total_price =
      calculatedTotalPrice.toFixed(2);

    form.setFieldsValue(newValues);
    calculateTotalPrice();
  };

  const handleDiscountAdd = (value, index) => {
    const newValues = form.getFieldsValue();
    const quantity = newValues.products[index].quantity;
    const rateKey = newValues.products[index].selling_price;

    const calculatedTotalPrice = rateKey * quantity;

    if (value) {
      const discountedTotalPrice = Math.max(calculatedTotalPrice - value, 0);
      newValues.products[index].product_total_price =
        discountedTotalPrice?.toFixed(1);
    } else {
      newValues.products[index].product_total_price =
        calculatedTotalPrice?.toFixed(1);
    }

    form.setFieldsValue(newValues);
    calculateTotalPrice();
  };

  const handleTotalPaidChange = () => {
    const totalPaid = parseFloat(form.getFieldValue("total_paid")) || 0;
    const totalPrice = parseFloat(form.getFieldValue("total_price")) || 0;

    const due = Math.max(totalPrice - totalPaid, 0);

    form.setFieldsValue({
      due: due.toFixed(2),
    });
  };

  const handleSubmit = (data) => {
    const totalPurchasePrice = data?.products?.reduce((total, item) => {
      return (
        total + parseFloat(item?.purchase_price) * parseFloat(item?.quantity)
      );
    }, 0);
    data.product_total_purchase_price = totalPurchasePrice;

    setLoading(true);
    axios
      .post(
        `${config.baseUrl}/inventory/sales_create/${userProfile?.employee_id}/`,
        {
          data: data,
        },
        {
          headers: authHeader(),
        }
      )
      .then((result) => {
        setLoading(false);
        if (result?.status === 201) {
          Swal.fire({
            title: "Success",
            text: "Invoice Created Successful",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            fetchGuiProductList();
            form.resetFields();
            form.setFieldsValue({
              products: [],
            });
            setOrderType([]);
            setViewModal(true);
            setInvoiceResponse(result?.data);
            setInvoiceData(data);
            setIsBackLog(false);
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        Swal.fire({
          title: "error",
          text: error?.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      });
  };

  const handleInvoiceModalClose = () => {
    setViewModal(false);
  };

  return (
    <>
      <InvoiceModal
        visible={viewModal}
        handleInvoiceModalClose={handleInvoiceModalClose}
        responseData={invoiceResponseData}
        data={invoiceData}
      />
      {customerModalVisibility && (
        <CustomerModal
          visible={customerModalVisibility}
          modalClose={handleModalClose}
          center_id={userProfile?.employee_id}
        />
      )}

      <div className="farmerDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>GUI POS</h5>
        </div>
        <div className="farmerDashboardContainer shadow-sm rounded">
          <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
            <div
              className="shadow-sm p-3"
              style={{ border: "1px solid #46604A" }}
            >
              <Form
                form={form}
                color="#46604A"
                onFinish={handleSubmit}
                layout="vertical"
              >
                <div className="d-flex justify-content-between">
                  <div>
                    <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                      <Col style={{ width: "200px" }}>
                        <Form.Item
                          hasFeedback
                          name="is_back_log_data"
                          valuePropName="checked"
                          onChange={handleBackLogData}
                        >
                          <Checkbox>Is this backlog data?</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col style={{ width: "200px" }}>
                        <Form.Item
                          hidden={isBackLog ? false : true}
                          hasFeedback
                          name="sales_date"
                          rules={[
                            {
                              required: isBackLog ? true : false,
                              message: "Please insert sale date",
                            },
                          ]}
                        >
                          <DatePicker format="YYYY-MM-DD" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                      <Col style={{ width: "400px" }}>
                        <Form.Item
                          hasFeedback
                          label="Customer Type"
                          name="customer_type"
                          rules={[
                            {
                              required: true,
                              message: "Please select customer type",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Type"
                            onChange={handleOrderType}
                          >
                            <Option value="Farmer">Farmer</Option>
                            <Option value="Retailer">Retailer</Option>
                            <Option value="Contract">Contract Farmer</Option>
                            <Option value="Institutional">
                              Institutional Buyer
                            </Option>
                            <Option value="Regular">Regular</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      {orderType.includes("Farmer") &&
                        renderPhoneField("Farmer")}
                      {orderType.includes("Retailer") &&
                        renderPhoneField("Retailer")}
                      {orderType.includes("Regular") &&
                        renderPhoneField("Regular")}
                      {orderType.includes("Institutional") &&
                        renderPhoneField("Institutional")}
                      {/* {orderType.includes("Farmer") && (
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            label="Customer Number"
                            name="phoneNumber"
                            onChange={(e) => handleFarmerInfo(e)}
                            rules={[
                              {
                                required: true,
                                message: "Please enter customer's phone number",
                              },
                              {
                                pattern: /^(?:\+?88)?01[3-9]\d{8}$/,
                                message: "Please enter a valid phone number",
                              },
                            ]}
                          >
                            <AutoComplete
                              options={options}
                              onSearch={handlePhoneSearch}
                              onSelect={handlePhoneSelect}
                              placeholder="Phone Number"
                              value={phone}
                            >
                              <Input type="tel" />
                            </AutoComplete>
                          </Form.Item>
                        </Col>
                      )}

                      {orderType.includes("Retailer") && (
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            label="Customer Number"
                            name="phone_number"
                            onChange={handleRetailerInfo}
                            rules={[
                              {
                                required: true,
                                message: "Please enter customer's phone number",
                              },
                              {
                                pattern: /^(?:\+?88)?01[3-9]\d{8}$/,
                                message: "Please enter a valid phone number",
                              },
                            ]}
                          >
                            <AutoComplete
                              options={options}
                              onSearch={handlePhoneSearch}
                              onSelect={handlePhoneSelect}
                              placeholder="Phone Number"
                              value={phone}
                            >
                              <Input placeholder="Phone Number" type="tel" />
                            </AutoComplete>
                          </Form.Item>
                        </Col>
                      )}
                      {orderType.includes("Regular") && (
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            label="Customer Number"
                            name="phone_number"
                            onChange={handleRegularCustomerInfo}
                            rules={[
                              {
                                required: true,
                                message: "Please enter customer's phone number",
                              },
                              {
                                pattern: /^(?:\+?88)?01[3-9]\d{8}$/,
                                message: "Please enter a valid phone number",
                              },
                            ]}
                          >
                            <AutoComplete
                              options={options}
                              onSearch={handlePhoneSearch}
                              onSelect={handlePhoneSelect}
                              placeholder="Phone Number"
                              value={phone}
                            >
                              <Input placeholder="Phone Number" type="tel" />
                            </AutoComplete>
                          </Form.Item>
                        </Col>
                      )}
                      {orderType.includes("Institutional") && (
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            label="Customer Number"
                            name="phoneNumber"
                            onChange={handleInstitutionalInfo}
                            rules={[
                              {
                                required: true,
                                message: "Please enter customer's phone number",
                              },
                              {
                                pattern: /^(?:\+?88)?01[3-9]\d{8}$/,
                                message: "Please enter a valid phone number",
                              },
                            ]}
                          >
                            <AutoComplete
                              options={options}
                              onSearch={handlePhoneSearch}
                              onSelect={handlePhoneSelect}
                              placeholder="Phone Number"
                              value={phone}
                            >
                              <Input placeholder="Phone Number" type="tel" />
                            </AutoComplete>
                          </Form.Item>
                        </Col>
                      )} */}
                      {orderType.includes("Contract") && (
                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                          <Col style={{ width: "200px" }}>
                            <Form.Item
                              hasFeedback
                              label="Project Name"
                              name="project_id"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select project",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Project"
                                onChange={handleProjectInfo}
                              >
                                {projects?.map((project, index) => (
                                  <Option
                                    value={project?.project_id}
                                    key={index}
                                  >
                                    {project?.project_name +
                                      " - " +
                                      project?.project_type +
                                      " - " +
                                      project?.year}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "200px" }}>
                            <Form.Item
                              hasFeedback
                              label="Group Name"
                              name="group_name"
                              rules={[
                                {
                                  required: true,
                                  message: "Please select group name",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select group"
                                showSearch
                                onChange={handleContractFarmerGroup}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {selectedProject?.names?.map((group, index) => (
                                  <Option key={index} value={group.group}>
                                    {group.group}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      )}
                    </Row>
                    {orderType.includes("Farmer") && (
                      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            name="farmer_name"
                            rules={[
                              {
                                required: true,
                                message: "Farmer name required",
                              },
                            ]}
                          >
                            <Input placeholder="Farmer Name" readOnly />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            name="farmer_id"
                            rules={[
                              {
                                required: true,
                                message: "Farmer ID required",
                              },
                            ]}
                          >
                            <Input placeholder="Farmer ID" readOnly />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {orderType.includes("Regular") && (
                      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            name="regular_customer_name"
                            rules={[
                              {
                                required: true,
                                message: "Regular customer name required",
                              },
                            ]}
                          >
                            <Input
                              placeholder="Regular customer Name"
                              readOnly
                            />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            name="regular_customer_id"
                            rules={[
                              {
                                required: true,
                                message: "Regular Customer ID required",
                              },
                            ]}
                          >
                            <Input placeholder="Regular Customer ID" readOnly />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {orderType.includes("Retailer") && (
                      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            name="retailer_name"
                            rules={[
                              {
                                required: true,
                                message: "Please enter retailer's name",
                              },
                            ]}
                          >
                            <Input placeholder="Retailer Name" readOnly />
                          </Form.Item>
                        </Col>
                        <Col style={{ width: "400px" }}>
                          <Form.Item
                            hasFeedback
                            name="retailer_id"
                            rules={[
                              {
                                required: true,
                                message: "Retailer ID is required",
                              },
                            ]}
                          >
                            <Input placeholder="Retailer ID" readOnly />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}

                    {orderType.includes("Contract") && (
                      <>
                        {orderType.includes("Contract") &&
                          renderPhoneField("Contract")}
                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }]}>
                          <Col style={{ width: "400px" }}>
                            <Form.Item
                              hasFeedback
                              name="contract_farmer_name"
                              rules={[
                                {
                                  required: true,
                                  message: "Farmer name required",
                                },
                              ]}
                            >
                              <Input placeholder="Farmer Name" readOnly />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "400px" }}>
                            <Form.Item
                              hasFeedback
                              name="contract_farmer_id"
                              rules={[
                                {
                                  required: true,
                                  message: "Farmer ID required",
                                },
                              ]}
                            >
                              <Input placeholder="Farmer ID" readOnly />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}
                    {orderType.includes("Institutional") && (
                      <Col style={{ width: "400px" }}>
                        <Form.Item
                          hasFeedback
                          name="institutional_buyer_name"
                          rules={[
                            {
                              required: true,
                              message: "Institutional Buyer name required",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Institutional Buyer Name"
                            readOnly
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </div>

                  <Col>
                    <Form.Item>
                      <Button
                        className="mt-4"
                        onClick={openCustomerModal}
                        style={{ color: "#ffffff", backgroundColor: "#46604A" }}
                      >
                        Add Customer
                      </Button>
                    </Form.Item>
                  </Col>
                </div>

                <Form.List name="products">
                  {(fields, { add, remove }) => (
                    <div
                      className="p-3 mb-5"
                      style={{ color: "#46604A", border: "1px solid #46604A" }}
                    >
                      <Col lg={4}>
                        <Form.Item>
                          <Button
                            type="default"
                            onClick={() => add()}
                            block
                            size="small"
                            icon={<PlusOutlined />}
                            style={{ color: "#000000" }}
                          >
                            Add product
                          </Button>
                        </Form.Item>
                      </Col>
                      {fields.length === 0 && (
                        <Space key="initial" align="baseline">
                          <Col style={{ width: "160px" }}>
                            <Form.Item
                              label="Product Name"
                              name={[0, `product_name`]}
                              rules={[
                                {
                                  required: true,
                                  message: "Product is required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select product name"
                                showSearch
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(value) =>
                                  filterProductList(value, 0)
                                }
                              >
                                {distinct_product_name?.map(
                                  (product, index) => (
                                    <Option key={index} value={product}>
                                      {product}
                                    </Option>
                                  )
                                )}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "160px" }}>
                            <Form.Item
                              label="Batch ID"
                              name={[0, `batch_id`]}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select batch ",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select batch id"
                                showSearch
                                onChange={(value) =>
                                  handleProductSelect(value, 0)
                                }
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                {filteredProductsList?.map((item) => (
                                  <Option
                                    key={item.batch_id}
                                    value={item.batch_id}
                                  >
                                    {item.batch_id}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "160px" }}>
                            <Form.Item
                              label="Product Name"
                              name={[0, `product_status`]}
                              initialValue={"Fresh"}
                              rules={[
                                {
                                  required: true,
                                  message: "Product status is required",
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select product status"
                                showSearch
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              >
                                <Option value="Fresh">Fresh</Option>
                                <Option value="Broken">Broken</Option>
                                <Option value="Damage">Damage</Option>
                                <Option value="Yolk">Yolk</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "120px" }}>
                            <Form.Item
                              label="Remaining Stock"
                              name={[0, `remaining_stock`]}
                            >
                              <Input placeholder="Remaining Stock" readOnly />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "0px" }}>
                            <Form.Item name={[0, `purchase_price`]}>
                              <Input hidden />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "120px" }}>
                            <Form.Item
                              label="Price"
                              name={[0, `selling_price`]}
                              rules={[
                                {
                                  required: true,
                                  message: "Product price required",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Price"
                                onChange={(e) =>
                                  handleSaleRateChange(e.target.value, 0)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "120px" }}>
                            <Form.Item
                              label="Quantity"
                              name={[0, `quantity`]}
                              rules={[
                                {
                                  required: true,
                                  message: "Purchase quantity required",
                                },
                                {
                                  pattern: /^[0-9]+$/,
                                  message: "Only english number",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Quantity"
                                onChange={(e) =>
                                  handleQuantityChange(e.target.value, 0)
                                }
                              />
                            </Form.Item>
                          </Col>

                          <Col style={{ width: "120px" }}>
                            <Form.Item
                              label="Discount"
                              name={[0, `discount`]}
                              initialValue={0}
                              rules={[
                                {
                                  pattern: /^[0-9]+(\.[0-9]+)?$/,
                                  message: "Only english number",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Discount"
                                onChange={(e) =>
                                  handleDiscountAdd(e.target.value, 0)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col style={{ width: "160px" }}>
                            <Form.Item
                              label="Product Total Price"
                              name={[0, `product_total_price`]}
                              rules={[
                                {
                                  required: true,
                                  message: "Product Total Price required",
                                },
                                {
                                  pattern: /^[0-9]+(\.[0-9]+)?$/,
                                  message: "Only english number",
                                },
                              ]}
                            >
                              <Input
                                placeholder="Product Total Price"
                                readOnly
                              />
                            </Form.Item>
                          </Col>
                        </Space>
                      )}
                      {fields.map(({ key, name, ...restField }, index) => (
                        <Space key={key} align="baseline">
                          <Row gutter={[8, 16, 24, 32]}>
                            <Col style={{ width: "160px" }}>
                              <Form.Item
                                {...restField}
                                label="Product Name"
                                name={[name, `product_name`]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Product is required",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select product name"
                                  showSearch
                                  onChange={(value) =>
                                    filterProductList(value, index)
                                  }
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {distinct_product_name?.map(
                                    (product, index) => (
                                      <Option key={index} value={product}>
                                        {product}
                                      </Option>
                                    )
                                  )}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col style={{ width: "160px" }}>
                              <Form.Item
                                label="Batch ID"
                                name={[name, `batch_id`]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please select batch ",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select batch id"
                                  showSearch
                                  onChange={(value) =>
                                    handleProductSelect(value, index)
                                  }
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  {filteredProductsList?.map((item) => (
                                    <Option
                                      key={item.batch_id}
                                      value={item.batch_id}
                                    >
                                      {item.batch_id}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col style={{ width: "160px" }}>
                              <Form.Item
                                label="Product Status"
                                name={[name, `product_status`]}
                                initialValue={"Fresh"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Product status is required",
                                  },
                                ]}
                              >
                                <Select
                                  placeholder="Select product status"
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.children
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                  }
                                >
                                  <Option value="Fresh">Fresh</Option>
                                  <Option value="Broken">Broken</Option>
                                  <Option value="Damage">Damage</Option>
                                  <Option value="Yolk">Yolk</Option>
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col style={{ width: "120px" }}>
                              <Form.Item
                                label="Remaining Stock"
                                name={[name, `remaining_stock`]}
                              >
                                <Input placeholder="Remaining Stock" readOnly />
                              </Form.Item>
                            </Col>

                            <Col style={{ width: "0px" }}>
                              <Form.Item name={[name, `purchase_price`]}>
                                <Input hidden />
                              </Form.Item>
                            </Col>

                            <Col style={{ width: "120px" }}>
                              <Form.Item
                                {...restField}
                                label="Price"
                                name={[name, `selling_price`]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Selling price required",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Price"
                                  onChange={(e) =>
                                    handleSaleRateChange(e.target.value, index)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col style={{ width: "120px" }}>
                              <Form.Item
                                {...restField}
                                label="Quantity"
                                name={[name, `quantity`]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Purchase quantity required",
                                  },
                                  {
                                    pattern: /^[0-9]+$/,
                                    message: "Only english number",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Quantity"
                                  onChange={(e) =>
                                    handleQuantityChange(e.target.value, index)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col style={{ width: "120px" }}>
                              <Form.Item
                                {...restField}
                                label="Discount"
                                name={[name, `discount`]}
                                initialValue={0}
                                rules={[
                                  {
                                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                                    message: "Only english number",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Discount"
                                  onChange={(e) =>
                                    handleDiscountAdd(e.target.value, index)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col style={{ width: "160px" }}>
                              <Form.Item
                                {...restField}
                                label="Product Total Price"
                                name={[name, `product_total_price`]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Product Total Price required",
                                  },
                                  {
                                    pattern: /^[0-9]+(\.[0-9]+)?$/,
                                    message: "Only english number",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Product Total Price"
                                  readOnly
                                />
                              </Form.Item>
                            </Col>

                            {fields.length > 1 ? (
                              <Button
                                className="align-self-center"
                                onClick={() => {
                                  form.setFieldsValue({
                                    total_price: undefined,
                                    due: undefined,
                                    total_paid: undefined,
                                  });
                                  remove(name);
                                  calculateTotalPrice();
                                }}
                                style={{
                                  backgroundColor: "#c21807",
                                  color: "#ffffff",
                                }}
                              >
                                <MinusCircleOutlined />
                              </Button>
                            ) : null}
                          </Row>
                        </Space>
                      ))}
                    </div>
                  )}
                </Form.List>
                <p
                  className="text-center"
                  style={{ color: "#46604A", fontSize: 16 }}
                >
                  <strong>Payment Method </strong>
                </p>
                <div className="d-flex shadow-sm mb-4">
                  <div
                    className="w-50 pt-4 d-flex justify-content-center"
                    style={{ color: "#46604A", border: "1px solid #46604A" }}
                  >
                    <Form.Item className="ms-2">
                      <Input
                        className="py-2 text-center custom-placeholder-color"
                        placeholder="Cash"
                        disabled
                        style={{ color: "#46604A", borderColor: "#46604A" }}
                      />
                    </Form.Item>
                    <Form.Item
                      className="ms-2"
                      name="total_paid"
                      rules={[
                        {
                          required: true,
                          message: "Total paid required",
                        },
                        {
                          pattern: /^[0-9]+$/,
                          message: "Only english number",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const totalPaid = parseFloat(value) || 0;
                            const totalPrice =
                              parseFloat(getFieldValue("total_price")) || 0;

                            if (totalPaid > totalPrice) {
                              return Promise.reject(
                                new Error(
                                  "Total paid cannot be greater than total price."
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}
                    >
                      <Input
                        className="py-2 text-center"
                        placeholder="Paid"
                        onChange={handleTotalPaidChange}
                        style={{ color: "#46604A", borderColor: "#46604A" }}
                      />
                    </Form.Item>
                  </div>
                  <div
                    className="w-50 pt-4"
                    style={{ color: "#46604A", border: "1px solid #46604A" }}
                  >
                    <div className="d-flex justify-content-center">
                      <Form.Item className="ms-2">
                        <Input
                          className="py-2 text-center custom-placeholder-color"
                          placeholder="Total"
                          disabled
                          style={{ color: "#46604A", borderColor: "#46604A" }}
                        />
                      </Form.Item>

                      <Form.Item
                        className="ms-2"
                        name="total_price"
                        rules={[
                          {
                            required: true,
                            message: "Total price missing",
                          },
                          {
                            validator: (_, value) => {
                              const totalPrice = parseFloat(value);
                              if (isNaN(totalPrice) || totalPrice <= 0) {
                                return Promise.reject(
                                  new Error("Total must be greater than zero.")
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <Input
                          className="py-2 text-center"
                          placeholder="Total Price"
                          readOnly
                          style={{ color: "#46604A", borderColor: "#46604A" }}
                        />
                      </Form.Item>
                    </div>
                    <div className="d-flex justify-content-center">
                      <Form.Item className="ms-2">
                        <Input
                          className="py-2 text-center custom-placeholder-color"
                          placeholder="Due"
                          disabled
                          style={{ color: "#46604A", borderColor: "#46604A" }}
                        />
                      </Form.Item>
                      <Form.Item className="ms-2" name="due" initialValue={0}>
                        <Input
                          className="py-2 text-center"
                          placeholder="Due Amount"
                          readOnly
                          style={{ color: "#46604A", borderColor: "#46604A" }}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>

                <Form.Item className="d-flex justify-content-end ">
                  <Button
                    htmlType="submit"
                    disabled={loading}
                    style={{ color: "#ffffff", backgroundColor: "#46604A" }}
                  >
                    Submit
                    {loading && <Spin size="small" style={{ marginLeft: 8 }} />}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
